import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ANIMATION_CLASSES } from '@/js/lib/constants';
import { TRIGGER_START } from './base';

gsap.registerPlugin(ScrollTrigger);

const els = document.querySelectorAll<HTMLElement>('.js-animate-fade-in');

export default function animateFadeIn(el: HTMLElement) {
  const { children } = el;
  const animateChildren = el.dataset.animateChildren !== undefined;
  const target = animateChildren ? children || el : el;

  gsap.set(target, {
    y: 60,
    opacity: 0,
  });

  el.classList.add(ANIMATION_CLASSES.rigged);
  el.classList.add(ANIMATION_CLASSES.noTransitions);

  gsap.to(target, {
    scrollTrigger: {
      trigger: el,
      start: TRIGGER_START,
    },
    ease: 'custom-ease',
    y: 0,
    opacity: 1,
    duration: 1,
    stagger: 0.1,
    onComplete: () => {
      el.classList.remove(ANIMATION_CLASSES.noTransitions);
    },
  });
}
els.forEach(animateFadeIn);
